import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { AuthService } from '@app/shared/services/auth.service';
import { take } from 'rxjs';

@Component({
  selector: 'proffeo-sign-out',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: ''
})
export class SignOutComponent implements OnInit {
  private readonly authService: AuthService = inject(AuthService);

  public ngOnInit(): void {
    this.authService.signOut().pipe(take(1)).subscribe();
  }
}
